/**
 * Cantidad de stock con decimales (kg, litros). Misma regla que
 * functions/utils/stockSucursalCanon.js#roundStockQty: 3 decimales; acepta coma decimal.
 */
export function roundStockQty(value) {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? '').trim().replace(',', '.'));
  if (!Number.isFinite(n)) return 0;
  return parseFloat(n.toFixed(3));
}
